import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { memoize } from '../../../../../core/decorators/memoize';
import { InfoWindowViewModel } from '../../map-local-store.service';
import { MarkerLocation } from '../../map-utils';
import { isCcCandidate } from '../../../location-utils';
import { MatDivider } from '@angular/material/divider';
import { CCActionButtonsComponent } from '../../../cc-list/cc-action-buttons/cc-action-buttons.component';
import { GtagEventDirective } from '../../../../../core/gx-gtag/gtag-event.directive';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass, NgStyle } from '@angular/common';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-info-window-content',
    templateUrl: './info-window-content.component.html',
  styleUrls: ['../../../../../../assets/scss/partials/info-window-close-button.scss',
                './info-window-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        LetDirective,
        NgClass,
        NgStyle,
        MatTooltip,
        GtagEventDirective,
        CCActionButtonsComponent,
        MatDivider,
    ],
})
export class InfoWindowContentComponent {
  @Input() viewModel$: Observable<InfoWindowViewModel>;
  @Output() scrollGridRowIntoView = new EventEmitter<MarkerLocation>();
  @Output() highlightGridRow = new EventEmitter<MarkerLocation>();
  @Output() removeHighlightFromGridRow = new EventEmitter<MarkerLocation>();

  // for use in HTML
  isCcCandidate = isCcCandidate;

  constructor(private sanitizer: DomSanitizer) {
  }

  @memoize()
  getSafeMarkerSvgUrl(markerSvgUrl: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustUrl(markerSvgUrl);
  }


  /**
   * Determine whether divider line will be rendered between marker locations
   * @param markerLocations
   * @param i
   * @param focusedLocationId
   */
  showDivider(markerLocations: MarkerLocation[],
              i: number,
              focusedLocationId: number): boolean {
    // do not render divider line after last marker location
    if (i === markerLocations.length - 1) {
      return false;
    }

    // if there is no focused location present, do render divider lines between each location/ccLocation
    if (!markerLocations.find(ml => ml.location.id === focusedLocationId)) {
      return true;
    }

    // render divider only if the next MarkerLocation is of type Location
    // MarkerLocations are sorted such that if there are ccLocations, they will appear right after
    // the focused location and we do not want to render divider lines between ccLocations in this case
    const nextMarkerLocation = markerLocations[i + 1];
    return !isCcCandidate(nextMarkerLocation.location);
  }

  /**
   * Stretch the a. buttons containers only if there are CCLocations among markerLocations
   * so that there isn't unnecessary white space if there aren't any
   * @param markerLocations
   */
  @memoize()
  stretchActionButtonsContainer(markerLocations: MarkerLocation[]): boolean {
    return !!markerLocations.find(ml => isCcCandidate(ml.location));
  }

  /**
   * When using immutable data src, markers will be re-rendered whenever there's an underlying
   * data update, causing them to be re-rendered which causes flickering - this solves it
   * https://angular.io/api/core/TrackByFunction
   * https://github.com/angular/angular/issues/11727
   * https://github.com/ngrx/store/issues/176
   * @param index
   * @param item
   */
  trackByFn(index: any, item: any) {
    return index;
  }
}

